module.exports = __webpack_public_path__ + "media/images/bnr_referral_home-804bf2c417b5cb1374aeb198b0a61a8b.jpg";